import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cos-form-line"
}
const _hoisted_2 = { class: "flex" }

import { ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import { activation } from '@/api/gucangSales/customerCenter'
import GcCodeSelect from '@/components/GcCodeSelect'
import { layoutTags } from '@dc-platform/dc-interaction'
import { useRoute, useRouter } from 'vue-router'
import { selectForNumberValidate } from '@/utils/validate'

const __default__ = { name: 'DcCosFbuCustomerActive' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()
const formRef = ref()
const form = ref<{
  contracts: {
    arkCode?: string
    contractCode?: string
    contractSubject?: string
    serviceSubject?: number
  }[]
}>({
  contracts: [{}]
})
const resetValue = ref({
  contracts: [{}]
})
const permissionBasic = {
  save: 'fbu_potential_contract_btn'
}
const hanleAdd = () => {
  form.value.contracts.push({})
}
const hanleDel = (index: number) => {
  form.value.contracts.splice(index, 1)
}
const handleSubmit = () => {
  // 转签约 或者流失激活
  activation({
    cosId: route.query.cosId,
    contracts: form.value.contracts
  }).then((res) => {
    layoutTags.close()
    message.success('操作成功')
    let type = 'contract'
    if (route.query.type === 'clients') {
      type = 'clients'
    }
    router.push({
      path: `/fbu/${type}`
    })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            ref_key: "formRef",
            ref: formRef,
            name: "advanced_search",
            model: form.value
          }, {
            default: _withCtx(() => [
              _createVNode(_component_dc_layout_card, {
                title: "合同信息（至少填写一个）",
                span: 12
              }, {
                subTitle: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "primary",
                    onClick: hanleAdd,
                    ghost: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("新增")
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.contracts, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                      index
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_dc_form_item, {
                        label: "法务合同编码",
                        name: ['contracts', index, 'contractCode'],
                        rules: {
                message: '请输入',
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: item.contractCode,
                            "onUpdate:value": ($event: any) => ((item.contractCode) = $event),
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1032, ["name"]),
                      _createVNode(_component_dc_form_item, {
                        label: "签约主体",
                        name: ['contracts', index, 'contractSubject'],
                        rules: {
                message: '请输入',
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CosInput, {
                            value: item.contractSubject,
                            "onUpdate:value": ($event: any) => ((item.contractSubject) = $event),
                            placeholder: "请输入"
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1032, ["name"]),
                      _createVNode(_component_dc_form_item, {
                        label: "服务主体",
                        name: ['contracts', index, 'serviceSubject'],
                        rules: {
                message: '请选择',
                validator: _unref(selectForNumberValidate),
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ParamCodesSelect, {
                            paramCode: "fbu_service_body",
                            appId: "cos_fbu",
                            value: item.serviceSubject,
                            "onUpdate:value": ($event: any) => ((item.serviceSubject) = $event)
                          }, null, 8, ["value", "onUpdate:value"])
                        ]),
                        _: 2
                      }, 1032, ["name", "rules"]),
                      _createVNode(_component_dc_form_item, {
                        label: "子客户代码",
                        span: 12,
                        name: ['contracts', index, 'arkCode'],
                        rules: {
                message: '请选择',
                required: true
              }
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_2, [
                            _createVNode(_unref(GcCodeSelect), {
                              label: item.arkCode,
                              "onUpdate:label": ($event: any) => ((item.arkCode) = $event),
                              value: item.arkCodeId,
                              "onUpdate:value": ($event: any) => ((item.arkCodeId) = $event),
                              cosId: _unref(route).query.cosId,
                              requiredCosId: true
                            }, null, 8, ["label", "onUpdate:label", "value", "onUpdate:value", "cosId"]),
                            _withDirectives(_createVNode(_component_a_button, {
                              type: "text",
                              danger: "",
                              style: {"padding-right":"0"},
                              onClick: ($event: any) => (hanleDel(index))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("删除")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]), [
                              [_vShow, form.value.contracts && form.value.contracts.length > 1]
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["name"])
                    ], 64))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_cos_footer_button, {
            value: form.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form).value = $event)),
            resetValue: resetValue.value,
            formRef: formRef.value,
            permissionPage: permissionBasic,
            disabled: false,
            onSubmit: handleSubmit
          }, null, 8, ["value", "resetValue", "formRef"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})